import React from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, FileText, Home, Inbox, FolderOpen, Layout, Briefcase, Calendar } from 'lucide-react';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const isActive = (path) => location.pathname.startsWith(path);
  const isExactDashboard = location.pathname === '/admin/dashboard';

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <img src="/logo.jpg" alt="Logo" className="sidebar-logo-img" />
          <h2>Backoffice</h2>
        </div>
        
        <nav className="sidebar-nav">
          <Link 
            to="/admin/dashboard" 
            className={`nav-item ${isExactDashboard ? 'active' : ''}`}
          >
            <Home size={20} />
            <span>Dashboard</span>
          </Link>
          
          <Link 
            to="/admin/dashboard/cms" 
            className={`nav-item ${isActive('/admin/dashboard/cms') ? 'active' : ''}`}
          >
            <Layout size={20} />
            <span>Conteúdos</span>
          </Link>
          
          <Link 
            to="/admin/dashboard/news" 
            className={`nav-item ${isActive('/admin/dashboard/news') ? 'active' : ''}`}
          >
            <FileText size={20} />
            <span>Notícias</span>
          </Link>
          
          <Link 
            to="/admin/dashboard/documents" 
            className={`nav-item ${isActive('/admin/dashboard/documents') ? 'active' : ''}`}
          >
            <FolderOpen size={20} />
            <span>Documentos</span>
          </Link>
          
          <Link 
            to="/admin/dashboard/submissions" 
            className={`nav-item ${isActive('/admin/dashboard/submissions') ? 'active' : ''}`}
          >
            <Inbox size={20} />
            <span>Submissões</span>
          </Link>
          
          <Link 
            to="/admin/dashboard/candidaturas" 
            className={`nav-item ${isActive('/admin/dashboard/candidaturas') ? 'active' : ''}`}
          >
            <Briefcase size={20} />
            <span>Candidaturas</span>
          </Link>
          
          <Link 
            to="/admin/dashboard/events" 
            className={`nav-item ${isActive('/admin/dashboard/events') ? 'active' : ''}`}
          >
            <Calendar size={20} />
            <span>Eventos</span>
          </Link>
        </nav>
        
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.name?.charAt(0)}</div>
            <div>
              <div className="user-name">{user?.name}</div>
              <div className="user-role">{user?.role}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            <LogOut size={20} />
          </button>
        </div>
      </aside>
      
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;